import apiClient from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type {
  ImportResult,
  Institution,
  InstitutionClass,
  InstitutionStudent,
  ProgressReport,
  ReportFilters,
  SharedCourse,
} from '../types'

export const institutionApi = {
  fetchInstitution: () => apiClient.get<ApiResponse<Institution>>('/institution'),

  fetchStudents: () =>
    apiClient.get<ApiResponse<InstitutionStudent[]>>('/institution/students'),

  importStudents: (file: File) => {
    const form = new FormData()
    form.append('file', file)

    return apiClient.post<ApiResponse<ImportResult>>('/institution/students/import', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  disableStudent: (userId: string) => apiClient.delete(`/institution/students/${userId}`),

  fetchClasses: () => apiClient.get<ApiResponse<InstitutionClass[]>>('/institution/classes'),

  createClass: (payload: { name: string; level?: string }) =>
    apiClient.post<ApiResponse<{ id: string; name: string }>>('/institution/classes', payload),

  assignStudent: (classId: string, userId: string) =>
    apiClient.post(`/institution/classes/${classId}/students`, { user_id: userId }),

  unassignStudent: (classId: string, userId: string) =>
    apiClient.delete(`/institution/classes/${classId}/students/${userId}`),

  fetchSharedCourses: () => apiClient.get<ApiResponse<SharedCourse[]>>('/institution/courses'),

  shareCourse: (payload: { course_id: string; class_id?: string | null }) =>
    apiClient.post<ApiResponse<{ id: string }>>('/institution/courses', payload),

  revokeShare: (courseId: string, classId?: string) =>
    apiClient.delete(`/institution/courses/${courseId}`, {
      params: classId ? { class_id: classId } : undefined,
    }),

  fetchProgressReport: (filters: ReportFilters) =>
    apiClient.get<ApiResponse<ProgressReport>>('/institution/reports/progress', {
      params: filters,
    }),

  /** Export brut : le corps est un fichier, pas une enveloppe JSON. */
  downloadReport: (filters: ReportFilters, format: 'csv' | 'html') =>
    apiClient.get<Blob>('/institution/reports/progress', {
      params: { ...filters, format },
      responseType: 'blob',
    }),
}
